"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./carousel-3d-item.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// @ts-check

/**
 * @typedef {object} Carousel3dImageData
 * @property {string} id Unique id for image
 * @property {string} url Image url
 * @property {string} title Title of the image, displayed below the image
 */

/**
 * @callback Carousel3dItemOnClick
 * @param {Carousel3dImageData} image Image being clicked
 * @returns {void}
 */

/**
 * @typedef {object} Props
 * @property {Carousel3dImageData} image
 * @property {number} totalImages
 * @property {number} index
 * @property {number} containerWidth
 * @property {number} rotation
 * @property {number} imageWidth
 * @property {number} imageHeight
 * @property {Carousel3dItemOnClick} onClick
 */

/**
 * Render an image with all of the necessary 3d transformations
 * @param {Props} props
 */
var Carousel3dItem = function Carousel3dItem(_ref) {
  var image = _ref.image,
      totalImages = _ref.totalImages,
      index = _ref.index,
      containerWidth = _ref.containerWidth,
      rotation = _ref.rotation,
      imageWidth = _ref.imageWidth,
      imageHeight = _ref.imageHeight,
      _onClick = _ref.onClick;

  var radius = _lodash["default"].clamp(containerWidth / 2, Carousel3dItem.minRadius, Carousel3dItem.maxRadius);

  var pos = index / totalImages * 360;
  var degrees = rotation - pos + 90;
  var radians = degrees * (Math.PI / 180);
  var offsetLeft = containerWidth / 2 - imageWidth / 2;
  var translateX = offsetLeft + radius * Math.cos(radians);
  var translateZ = radius * Math.sin(radians) - radius;
  var translateY = imageHeight * -index;
  var opacity = 1 - -translateZ / (radius * 2);
  var zIndex = Math.round(opacity * 100);
  var transform = "translate3d(".concat(translateX, "px, ").concat(translateY, "px, ").concat(translateZ, "px)");

  var img = _react["default"].createElement("img", {
    className: "image",
    style: {
      opacity: opacity
    },
    alt: image.title,
    width: imageWidth,
    height: imageHeight,
    src: image.url
  });

  var title = _react["default"].createElement("span", {
    className: "title",
    style: {
      opacity: Math.pow(opacity, 20)
    }
  }, image.title);
  /* eslint-disable jsx-a11y/click-events-have-key-events,
  jsx-a11y/no-static-element-interactions */


  return _react["default"].createElement("div", {
    key: image.title,
    onClick: function onClick() {
      return _onClick(image);
    },
    style: {
      zIndex: zIndex,
      transform: transform,
      width: imageWidth,
      height: imageHeight
    },
    className: "Carousel3dItem"
  }, img, title);
};

Carousel3dItem.minRadius = 300;
Carousel3dItem.maxRadius = 500;
Carousel3dItem.imageShape = _propTypes["default"].shape({
  id: _propTypes["default"].string,
  url: _propTypes["default"].string,
  title: _propTypes["default"].string
});
Carousel3dItem.propTypes = {
  image: Carousel3dItem.imageShape.isRequired,
  totalImages: _propTypes["default"].number.isRequired,
  index: _propTypes["default"].number.isRequired,
  containerWidth: _propTypes["default"].number.isRequired,
  rotation: _propTypes["default"].number.isRequired,
  imageWidth: _propTypes["default"].number.isRequired,
  imageHeight: _propTypes["default"].number.isRequired,
  onClick: _propTypes["default"].func.isRequired
};
var _default = Carousel3dItem;
exports["default"] = _default;